// node-modules
import clickOutside from 'click-outside';
import nodeContains from 'node-contains';
import PubSub from 'pubsub-js';
import { TweenLite } from 'gsap/TweenLite';

// constants
import { DOCUMENT_ELEMENT, SELECTORS, KEY_CODES, EVENTS } from '@/scripts/constants';

// other
import { toggleModal } from '@/scripts/utils/index';

// assets
import './HeaderNav.scss';

const defaults = {
  container: document,
  menuSelector: '[data-role="menu"]', // .menu,
  menuContainer: '[data-role="menu-list-container"]', // .menu__container inner
  menuScrollElement: '[data-role="menu-scroll-element"]', // .menu__container inner
  menuWrapper: '[data-role="menu-wrapper"]', // .menu__wrapper outer
  menuList: 'ul',
  menuListItem: 'li',
  menuTitle: '[data-role="menu-title"]', // .menu__title
  menuItemDecoration: '[data-role="menu-item-decorator"]', // .line
  menuTrigger: '[data-role="menu-trigger"]',
  activeClass: SELECTORS.menu_opened,
  hiddenClass: SELECTORS.hidden,
  disabledClass: SELECTORS.disabled,
  transitionDuration: 300,
};
export default class HeaderNav {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.mainContainer = options.container;

    this.menuSelector = options.menuSelector;
    this.menu = this.mainContainer.querySelector(options.menuSelector);
    this.menuTrigger = this.mainContainer.querySelectorAll(options.menuTrigger);
    this.menuContainer = this.menu.querySelector(options.menuContainer); // inner
    this.menuWrapperSelector = options.menuWrapper; // outer
    this.menuTitle = this.menu.querySelector(options.menuTitle);
    this.menuTitleText = this.menuTitle.querySelector('span');
    this.menuScrollElement = options.menuScrollElement;
    this.menuListSelector = options.menuList;
    this.menuList = this.menuContainer.querySelector(options.menuList);
    this.menuListItemSelector = options.menuListItem;
    this.transitionDuration = options.transitionDuration;

    if (options.menuItemDecoration) {
      this.menuItemDecoration = options.menuItemDecoration;
    }

    // helpers
    this.activeClass = options.activeClass;
    this.hiddenClass = options.hiddenClass;
    this.disabledClass = options.disabledClass;

    this.unbindClickOutside = null;
    this.keyUp = this.keyUp.bind(this);

    this.init();
  }

  get activeStatus() {
    return DOCUMENT_ELEMENT.classList.contains(this.activeClass);
  }

  openInner(e) {
    this.scrollToTop();
    this.reInit();
    const item = e.target.closest(this.menuListItemSelector) || e.target;
    const list = item.querySelector(this.menuListSelector).cloneNode(true);
    this.refreshList(list);
    // dlAnimate.remove(this.menuList, {
    //   name: 'menu',
    //   track: 'none',
    //   duration: this.transitionDuration,
    //   afterLeave: () => {
    //     this.menuTitle.classList.remove(this.hiddenClass);
    //     this.menuTitleText.innerHTML = listTitle;
    //     dlAnimate.insert(this.menuContainer, list, {
    //       name: 'menu',
    //       beforeEnter: (el) => {
    //         el.setAttribute('data-title', listTitle);
    //       },
    //     }, this.menuContainer.getElementsByTagName(this.menuListSelector)[0]);
    //   },
    // });
  }

  // goBack() {
  //   if (this.menuTitle.classList.contains(this.disabledClass)) return false;
  //   this.menuTitle.classList.add(this.disabledClass);
  //   this.reInit();
  //   const PREV_LISTS = this.menuContainer.querySelectorAll('.top-list');
  //   return dlAnimate.remove(PREV_LISTS[0], {
  //     name: 'menu',
  //     track: 'none',
  //     duration: this.transitionDuration,
  //     afterLeave: (el) => {
  //       dlAnimate.show(PREV_LISTS[1], {
  //         name: 'menu',
  //         beforeEnter: (innerEl) => {
  //           const { title } = innerEl.dataset;
  //           if (title) {
  //             this.menuTitleText.innerHTML = title;
  //           } else {
  //             this.menuTitle.classList.add(this.hiddenClass);
  //           }
  //         },
  //         afterEnter: () => {
  //           this.menuTitle.classList.remove(this.disabledClass);
  //         },
  //       });
  //       el.remove();
  //     },
  //   });
  // }

  toggleStatus({ force }) {
    this.scrollToTop();
    PubSub.publish(EVENTS.menuToggle, { isOpened: this.activeStatus });
    DOCUMENT_ELEMENT.classList.toggle(this.activeClass);
    return toggleModal(this.activeStatus, this.menuScrollElement, this.menu, force);
  }

  scrollToTop() {
    return TweenLite.to(
      this.menu,
      this.transitionDuration / 1000,
      { scrollTo: { y: 0, autoKill: false } },
    );
  }

  refreshList(list) {
    list.classList.add('top-list');
    Array.from(list.children).forEach((el) => {
      el.classList.add('top-item');
      if (el.classList.contains('has-children')) {
        el.addEventListener('click', (e) => {
          this.openInner(e);
        });
      }
    });
  }

  keyUp(e) {
    if (e.keyCode === KEY_CODES.esc && this.activeStatus) {
      this.toggleStatus();
    }
  }

  destroy() {
    if (this.activeStatus) {
      this.toggleStatus({
        force: true,
      });
    }
    this.unbindClickOutside();
    document.removeEventListener('keyup', this.keyUp);
  }

  init() {
    this.refreshList(this.menuList);
    this.menuTitle.addEventListener('click', (e) => {
      this.goBack(e);
    });
    document.addEventListener('keyup', this.keyUp);
    this.menuTrigger.forEach(trigger => trigger.addEventListener('click', this.toggleStatus.bind(this), false));
    this.unbindClickOutside = clickOutside(this.menu, (e) => {
      if (this.activeStatus) {
        if (Array.from(this.menuTrigger).find(el => nodeContains(el, e.target))) return;
        this.toggleStatus();
      }
    });
  }

  reInit() {
    this.menuList = this.menuContainer.querySelector(this.menuListSelector);
  }
}



// WEBPACK FOOTER //
// ./components/HeaderNav/HeaderNav.js